import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import UserProfile from "@/classes/userProfile";

@Module({
  namespaced: true,
  name: "User"
})
export default class User extends VuexModule {
  profile = new UserProfile();

  @Mutation
  updateProfile(user: UserProfile) {
    this.profile = user;
  }
}
